var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"download",attrs:{"href":_vm.link.href,"download":_vm.link.download}})])
}
var staticRenderFns = []

export { render, staticRenderFns }